const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const Locale = () => import(/* webpackChunkName: "locale" */ './view/locale.vue');

export const ROUTE_NAME_LOCALE = 'Locale';

export default [
    {
        path: '/app/:appId/locale',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_LOCALE,
                component: Locale,
                meta: { requiresAuth: true }
            }
        ]
    }
];
